var map = {
	"./calphalon.png": 1974,
	"./cuisinart.png": 1975,
	"./kitchenaid.png": 1976,
	"./lecreuset.png": 1977,
	"./libbey.png": 1978,
	"./oxo.png": 1979
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1973;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/registry/aboutZolaBrands nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 1973
// module chunks = 43